import { BidderRegister } from "Application/features/models/Home/BidderRegister";
import { queryResponse, sibaBackendApi } from "../../backends/sibaApis";
import { ExternalBid } from "Application/features/models/Home/ExternalBid";



const api = "api/salvageexternal/bidder";
/***
 * Service definition for BidderRegister
 *  */
const BidderRegisterApi = sibaBackendApi.injectEndpoints({
    endpoints: (builder) => ({
        /**
         * Get all endpoint
         *
         */
        queryAllBidderRegister: builder.query<BidderRegister[], void>({
            query: () => ({ url: `${api}`, method: "GET" })
        }),
        /**
         * Get by Id endpoint
         * query expects object with parameters Id.
         * Id destructured and passed as a query parameter.
         */
        queryBidderRegister: builder.query<queryResponse<BidderRegister>, string>({
            query: (Id: string) => ({ url: `${api}/${Id}`, method: "GET" })
        }),

        /**
         * Save  endpoint
         *
         */
        saveBidderRegister: builder.mutation<queryResponse<any>, BidderRegister>({
            query: (obj: BidderRegister) => ({
                url: `${api}/save`,
                method: "POST",
                //body: obj,
                data: obj
            })
        }),
        /**
         * Remove  endpoint
         * query expects object with parameters Id and modified by (string).
         * Id and modifiedby propertied destructured and passed as a query parameter.
         */
        removeBidderRegister: builder.mutation<queryResponse<number>, BidderRegister>({
            query: ({ Id, modifiedBy }: any) => ({
                url: `${api}/${Id}/${modifiedBy}`,
                method: "DELETE"
            })
        }),
        /**
         * Sample query method using rtk mutation instead of rtk query.
         */
        getAllBidderRegister: builder.mutation<BidderRegister[], void>({
            query: () => ({
                url: `${api}`,
                method: "GET"
            })
        }),
        getBidderRegisterByUserId: builder.mutation<BidderRegister, string>({
            query: (userId: string) => ({
                url: `${api}/${userId}`,
                method: "GET"
            })
        }),
        getBidderBidsById: builder.mutation<ExternalBid, string>({
            query: (Id: string) => ({
                url: `${api}/bids/${Id}`,
                method: "GET"
            })
        }),
        /***
         *  Search  Endpoint
         *  using rtk mutations instead of rtk for search.
         * @param query search form object of type ISearchForm.
         */
        searchBidderRegister: builder.mutation<queryResponse<BidderRegister[]>, any>({
            query: (query: any) => ({
                url: `${api}/search`,
                method: "POST",
                // body: query,
                data: query
            })
        }),
    })
});

export const {
   useGetAllBidderRegisterMutation,
   useQueryAllBidderRegisterQuery,
   useRemoveBidderRegisterMutation,
   useSaveBidderRegisterMutation,
   useGetBidderRegisterByUserIdMutation,
   useGetBidderBidsByIdMutation
} = BidderRegisterApi;
